import { FlowConditionEmailOpened } from './types.flow';

import { emptyEmailPointerParameterValue } from '../../FlowParameter/ParameterValue/Email';
import { FLOW_CONDITION_TYPES } from '../constants';

export default (): Omit<FlowConditionEmailOpened, 'id'> => ({
  type: FLOW_CONDITION_TYPES.EVENT_EMAIL_OPENED.type,
  email: emptyEmailPointerParameterValue(),
});
